/**
 * PageTabs — Reusable tab switcher (used for Job / Gig, but generic).
 *
 * Props:
 *   tabs       { id: string, label: string, icon: ReactElement }[]
 *   activeId   string
 *   onChange   (id: string) => void
 */
import { Link, useLocation } from "react-router-dom";
import styles from "./pageTabs.module.css";

export default function PageTabs({ tabs, onChange }) {
  const { pathname } = useLocation();

  return (
    <div className={styles.tabs} role="tablist">
      {tabs.map(({ id, label, icon }) => {
        const normalizedPath = pathname.replace(/\/$/, "");
        const active = normalizedPath === `/add-new-job/${id}`;

        return (
          <Link
            key={id}
            to={`/add-new-job/${id}`}
            role="tab"
            aria-selected={active}
            className={`${styles.tab} ${active ? styles.tabActive : ""}`}
            onClick={() => onChange?.(id)}
          >
            {icon}
            {label}
          </Link>
        );
      })}
    </div>
  );
}
